module.exports = "data:image/webp;base64,UklGRkAAAABXRUJQVlA4TDMAAAAvJ4AGADDTtg2YXuWvdmO3Lwh2EGYbzR9lbgO41xFk23ANdDgzucv7PwFCHnc/3uXg/wAA"